// @flow
/* eslint-disable no-multi-assign */

import React, { Fragment, useState, useEffect } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import HorizontalList from 'client/components/HorizontalList';
import hardChangeActiveItem from 'client/utils/hardChangeActiveItem';
import Navbar from 'client/components/Navbar';
import Loading from 'client/components/Loading';
import Styles from './styles';
import { getSearchResults, cancelGetSearchResults } from './redux';

type Props = {
  searchResultsList : any,
  getSearchResults : (data : string) => void,
  cancelGetSearchResults : () => void,
  getSearchResultsLoading : boolean,
  searchedQuery : string,
};

const FAalphabet = 'آ ا ب پ ت ث ج چ ح خ د ذ ر ز ژ س ش ص ض ط ظ ع غ ف ق ک گ ل م ن و ه ی'.split(' ');
const ENalphabet = _.map(_.reverse('abcdefghijklmnopqrstuvwxyz'.split('')), _.unary(_.toUpper));
const numbers = '0123456789'.split('');

let inputElement : any = null;
let selectInput : boolean = false;

const Search = ({
  searchedQuery,
  getSearchResults,
  cancelGetSearchResults,
  searchResultsList,
  getSearchResultsLoading,
} : Props) => {
  const [searchQuery, setSearchQuery] = useState('');

  const handleResize = () => {
    setTimeout(hardChangeActiveItem, 1000);
  };

  useEffect(() => {
    window.durationStorage = JSON.parse(localStorage.getItem('aparatTvPlayer')) || {};

    if (searchedQuery && !searchQuery) {
      setSearchQuery(searchedQuery);
    }

    inputElement = document.getElementById('searchInput');

    setInterval(() => {
      if (inputElement && inputElement.matches) {
        if (inputElement.classList.contains('activeItem')) {
          if (inputElement.classList.contains('firstFocus') && (!selectInput || !inputElement.matches(':focus'))) {
            inputElement.classList.remove('firstFocus');
            selectInput = true;
            inputElement.focus();
            if (typeof inputElement.selectionStart === 'number') {
              inputElement.selectionStart = inputElement.selectionEnd = inputElement.value.length;
            } else if (typeof inputElement.createTextRange !== 'undefined') {
              const range = inputElement.createTextRange();
              range.collapse(false);
              range.select();
            }
          }
        } else if (!inputElement.classList.contains('firstFocus')) {
          inputElement.classList.add('firstFocus');
          if (selectInput) {
            selectInput = false;
          }
          if (inputElement.matches(':focus')) {
            inputElement.blur();
          }
        }
      }
    }, 100);

    handleResize();
    window.addEventListener('resize', handleResize);
    document.getElementById('app').classList.add('w-100');

    return () => {
      window.removeEventListener('resize', handleResize);
      document.getElementById('app').classList.remove('w-100');
      inputElement.blur();
      cancelGetSearchResults();
    };
  }, []);

  const handleClickChar = (char : string) => {
    setSearchQuery(searchQuery ? `${searchQuery}${char}` : char);
  };

  const handleSearch = (e : any) => {
    e.preventDefault();
    if (searchQuery && searchQuery !== searchedQuery) {
      getSearchResults(searchQuery);
    }
  };

  const handleBackSpace = () => {
    if (searchQuery) {
      setSearchQuery(searchQuery.substring(0, searchQuery.length - 1));
    }
  };

  const handleTextInput = (e : any) => {
    setSearchQuery(e.target.value);
  };

  return (
    <Styles id="search-page">
      <Navbar />
      <div className={`searchBoxWrapper selectableRow preActiveRow${_.get(window, ['webOS', 'platform', 'tv']) ? ' lg' : ''}`}>
        <form onSubmit={handleSearch}>
          <input
            type="text"
            onChange={handleTextInput}
            value={searchQuery}
            placeholder="جستجو..."
            className="selectableItem preActiveItem firstFocus"
            id="searchInput"
            autoComplete="off"
            size="50"
          />
        </form>
        {
          !_.get(window, ['webOS', 'platform', 'tv']) && (
            <button
              className="selectableItem"
              onClick={handleSearch}
              clickable="true"
            >
              <i className="fa fa-search" />
            </button>
          )
        }
      </div>
      {
        !_.get(window, ['webOS', 'platform', 'tv']) && (
          <Fragment>
            <ul className="selectableRow">
              {
                FAalphabet.map((item : string) => (
                  <li key={item}>
                    <button
                      className="selectableItem"
                      onClick={() => handleClickChar(item)}
                      clickable="true"
                    >
                      {item}
                    </button>
                  </li>
                ))
              }
            </ul>
            <ul className="selectableRow">
              <li className="keybardAction">
                <button
                  className="keyboardButton backSpaceButton selectableItem"
                  onClick={handleBackSpace}
                  clickable="true"
                />
              </li>
              <li className="keybardAction">
                <button
                  className="keyboardButton spaceButton selectableItem"
                  onClick={() => handleClickChar(' ')}
                  clickable="true"
                />
              </li>
              {
                ENalphabet.map((item : string) => (
                  <li key={item}>
                    <button
                      className="selectableItem"
                      onClick={() => handleClickChar(item)}
                      clickable="true"
                    >
                      {item}
                    </button>
                  </li>
                ))
              }
            </ul>
            <ul className="selectableRow">
              {
                numbers.map((item : string) => (
                  <li key={item}>
                    <button
                      className="selectableItem"
                      onClick={() => handleClickChar(item)}
                      clickable="true"
                    >
                      {item}
                    </button>
                  </li>
                ))
              }
            </ul>
          </Fragment>
        )
      }
      <div className="listsContainer">
        {
          getSearchResultsLoading &&
          <Loading />
        }
        {
          (searchResultsList.size > 0 && searchResultsList.get('notFound'))
            ? <h1 style={{ color: '#fff' }}>موردی یافت نشد!</h1>
            : ((searchResultsList.size > 0) && searchedQuery) && (
            <HorizontalList
              listData={searchResultsList.get('0')}
              info={{ title: `نتیجه جستجو "${searchedQuery}"`, listType: 'video' }}
              size={17.5}
            />
          )
        }
      </div>
    </Styles>
  );
};

export default connect(
  (state : any) => ({
    getSearchResultsLoading: state.getIn(['Search', 'getSearchResultsLoading']),
    searchResultsList: state.getIn(['Search', 'searchResultsList']),
    searchedQuery: state.getIn(['Search', 'searchedQuery']),
  }),
  { getSearchResults, cancelGetSearchResults },
)(Search);
